import React from "react";
import {useTranslation} from "react-i18next";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import Switch from "@mui/material/Switch";

import Stack from "@mui/material/Stack";


const MeasurementTypesSection = ({formik }) => {
    const {t} = useTranslation(['stations']);

    return <Stack spacing={1}>
        <MDBox>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                {t('stationForm.measurementTypes')}
            </MDTypography>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" lineHeight={1}>
            <MDBox>
                <Switch checked={formik.values.acceptMod1}
                        onChange={(event) => formik.setFieldValue("acceptMod1", event.target.checked)}/>
            </MDBox>
            <MDBox width="100%">
                <MDTypography variant="button" fontWeight="regular" color="text">
                    {t('stationForm.acceptMod1')}
                </MDTypography>
            </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" lineHeight={1}>
            <MDBox>
                <Switch checked={formik.values.acceptMod23}
                        onChange={(event) => formik.setFieldValue("acceptMod23", event.target.checked)}/>
            </MDBox>
            <MDBox width="100%">
                <MDTypography variant="button" fontWeight="regular" color="text">
                    {t('stationForm.acceptMod23')}
                </MDTypography>
            </MDBox>
        </MDBox>

    </Stack>
}

export default MeasurementTypesSection;